import React, { ReactNode } from "react";

type LoadingHocProps = {
  loading: boolean;
  children?: ReactNode;
};

const Loading: React.FC<LoadingHocProps> = ({ loading, children }) =>
  loading ? <div className="loader element is-loading" /> : <>{children}</>;

export { Loading };
